/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { createContext } from 'fierry/react';


export default createContext(null);
